












import {Component, Prop, Vue, Watch} from 'vue-property-decorator';
import List from '@/views/document/section/List.vue';
import dokument from '@/store/modules/dokument';
import {ListSection} from '@/store/models';
import Toggle from '@/views/document/section/Toggle.vue';

@Component({components: {Toggle, List}})
export default class Intro extends Vue {
  @Prop() readonly group!: any;

  @Watch('agendaSection', {immediate: true, deep: true})
  onData1() {
    this.onData();
  }
  @Watch('listSection', {immediate: true, deep: true})
  onData2() {
    this.onData();
  }

  onData() {
    if (this.group.Hidden !== this.hidden) {
      const g = {
        Id: this.group.Id,
        Kind: this.group.Kind,
        Type: this.group.Type,
        SubType: this.group.SubType,
        Children: this.group.Children,
        Hidden: this.hidden,
      };
      dokument.updateItem(g);
    }
  }

  get agendaSection(): any {
    return dokument.getItems(this.group.Id)[0] as any;
  }

  get listSection(): ListSection {
    return dokument.getItems(this.group.Id)[1] as ListSection;
  }

  get hidden(): boolean {
    return this.listSection.Hidden && this.agendaSection.Hidden;
  }
}
